module.exports = __webpack_public_path__ + "1294c0c1f79e0283b8eaab5cf53acf54.png";